import { FunctionComponent } from 'react';
import * as React from 'react';
import classNames from 'classnames';

import { ALIGN } from '../../Common/constants';

import styles from './GridRow.scss';

type GridRowProps = {
    align?: typeof ALIGN.bottom | typeof ALIGN.center | typeof ALIGN.top;
    children: React.ReactNode;
    dataTn?: string;
};

export const GridRow: FunctionComponent<GridRowProps> = props => {
    const { align = 'top', children, dataTn } = props;
    const rowClassNames = classNames(styles.row, {
        [styles.bottom]: align === ALIGN.bottom,
        [styles.center]: align === ALIGN.center,
        [styles.top]: align === ALIGN.top,
    });

    return (
        <div className={rowClassNames} data-tn={dataTn}>
            {children}
        </div>
    );
};
